/**
 * Warnings and errors, in one place, never silent.
 */

import type { Diagnostic } from "../lib/compiler";

export function Diagnostics({ items }: { items: readonly Diagnostic[] }) {
  if (!items.length) return null;

  return (
    <ul className="m-0 mt-3 grid list-none gap-2 p-0">
      {items.map((d, i) => {
        const isError = d.level === "error";
        return (
          <li
            key={i}
            className={[
              "flex items-baseline gap-2 rounded-[2px] border-l-[5px] px-3 py-2 shadow-sm",
              isError ? "border-flag bg-flag/15" : "border-smb bg-smb/15",
            ].join(" ")}
          >
            <span
              className={[
                "shrink-0 font-display text-[12px] font-bold uppercase tracking-[0.1em]",
                isError ? "text-flag" : "text-smb",
              ].join(" ")}
            >
              {isError ? "Error" : "Warning"}
            </span>
            <span className="text-[13px] font-medium leading-snug text-graphite">
              {d.message}
            </span>
          </li>
        );
      })}
    </ul>
  );
}
